const EMPLOYMENT_TYPES = [
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_TYPES.UNEMPLOYED',
        value: 'unemployed',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_TYPES.RETIRED',
        value: 'retired',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_TYPES.EMPLOYED',
        value: 'employed',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_TYPES.SELF_EMPLOYED',
        value: 'selfEmployed',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_TYPES.STUDENT',
        value: 'student',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_TYPES.OTHER',
        value: 'other',
    },
];

const EMPLOYMENT_STATUS = [
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_STATUSES.FULL_TIME',
        value: 'FT',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_STATUSES.FULL_TIME_PROBATION',
        value: 'FTP',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_STATUSES.PART_TIME_CASUAL',
        value: 'PTC',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_STATUSES.PART_TIME_REGULAR',
        value: 'PTR',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_STATUSES.RETIRED',
        value: 'RET',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_STATUSES.SELF_EMPLOYED',
        value: 'SE',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_STATUSES.SEASONAL_SUMMER',
        value: 'SEAS',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYMENT_STATUSES.SEASONAL_WINTER',
        value: 'SEAW',
    },
];

const FINANCING_FREQUENCIES = [
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.INCOME_FREQUENCIES.YEARLY',
        value: '1',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.INCOME_FREQUENCIES.MONTHLY',
        value: '12',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.INCOME_FREQUENCIES.WEEKLY',
        value: '52',
    },
];

export { EMPLOYMENT_TYPES, EMPLOYMENT_STATUS, FINANCING_FREQUENCIES };
export default {
    EMPLOYMENT_TYPES,
    EMPLOYMENT_STATUS,
    FINANCING_FREQUENCIES,
};
